import { Component, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../Services/auth.service';

@Component({
  selector: 'app-admin-vetical-sidebar',
  templateUrl: './admin-vetical-sidebar.component.html',
  styleUrls: ['./admin-vetical-sidebar.component.css'],
  encapsulation: ViewEncapsulation.None,standalone:false
})
export class AdminVeticalSidebarComponent implements OnInit{
  roles:string;
  role:string='';
  isyes:boolean=false;
  constructor
  (
    private renderer: Renderer2,
    private auth:AuthService,
    private router: Router, private activatedRoute: ActivatedRoute
)
{

  this.roles=this.auth.getRoles();

}

showSidebar: boolean = true;
showSide:boolean=false;
logut(){
  this.auth.logout();
  this.router.navigate(['/login'])
}
toggleColumnLayout() {
  // Toggle the sidebar visibility
  this.showSidebar = !this.showSidebar;

  // Toggle the column layout
  if (this.showSidebar) {
    // Display the sidebar column and adjust widths
    this.renderer.addClass(document.querySelector('#db-wrapper'), 'toggled');
  } else {
    // Hide the sidebar column and adjust widths
    this.renderer.removeClass(document.querySelector('#db-wrapper'), 'toggled');
  }
}


  getClassForRoute(route: string): string {
    const currentUrl = this.router.url;

    const isActive   = this.router.isActive(route, true);

    if (isActive || currentUrl==route) {
      return 'nav-link u-sidebar-nav-menu__link active smooth-shadow-lg mb-1 text-white';
    } else {
      return 'nav-link u-sidebar-nav-menu__link mb-1';
    }
  }

  isRouteActive(routes: string[]): boolean {
    const currentUrl = this.router.url;
    if(routes.some(route => currentUrl.startsWith(route))){
      return true;
    }
    else{
      return routes.some(route => this.router.isActive(route, true));
    }
  }


  ngOnInit(): void {
    this.role=this.roles.toString();

    if(this.role==="Student"){
      this.isyes=false;
    }
    else{
      this.isyes=true;
    }
  }

}
